





























import { ModalConstants } from '@/core/constants';
import { GitAPI } from '@/services/api/api.git';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CommitChangesWindow extends Vue {
	id: string = ModalConstants.CommitChangesWindow;

    commitMessage: string = '';
    loading: boolean = false;

    commit() {
        this.loading = true;

        GitAPI.CommitChanges({ message: this.commitMessage })
            .then((result) => {
                if (result.data) {
                    this.$bvToast.toast('Changes comitted successfully', {
                        variant: 'success',
                        title: 'Success',
                        solid: true
                    });
                    this.$emit('committed');
                } else {
                    this.$bvToast.toast('There appears to be no changes to commit, or your changes do not successfully build.', {
                        variant: 'danger',
                        title: 'Error',
                        solid: true
                    });
                }

                this.$bvModal.hide(this.id);
            }).finally(() => {
                this.loading = false;
            });
    }
}
